import api from './utilBackoffice';

const controller = 'Proposta';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },
  DownloadExcel: dto => {
    return api.Axios.DownloadExcelFile(url + '/DownloadRelatorios', dto);
  },

  /* Canceladas */
  ListarCanceladas: dto => {
    return api.Axios.GetParams(url + '/Canceladas', dto);
  },

  /* Pendente Pagamento */
  ListarPendentePagamento: dto => {
    return api.Axios.GetParams(url + '/PendentePagamento', dto);
  },

  /* Pagas */
  ListarPagas: dto => {
    return api.Axios.GetParams(url + '/Pagas', dto);
  },
  RequestDownloadPagas: dto => {
    return api.Axios.Post(url + '/RequestDownloadPagas', dto);
  },

  /* Pagas e Cedidas */
  ListarPagasECedidas: dto => {
    return api.Axios.GetParams(url + '/PagasECedidas', dto);
  },
  RequestDownloadPagasECedidas: dto => {
    return api.Axios.Post(url + '/RequestDownloadPagasECedidas', dto);
  }
});
